import React, { useState, useCallback, useEffect } from 'react';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Chip,
  Divider,
  IconButton,
  CircularProgress,
  alpha,
  useTheme
} from '@mui/material';
import {
  Description as DescriptionIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  RemoveRedEye as VisibilityIcon,
  Close as CloseIcon,
  CloudUpload as CloudUploadIcon,
  InsertDriveFile as FileIcon
} from '@mui/icons-material';
import { useSelector } from 'react-redux';

// ---------------------------------------------------------------------------
// Maps a mime type (as found in allowed_file_types / file_type) to the short
// label shown in the "FORMATS:" row, e.g. 'image/png' -> 'PNG'.
// ---------------------------------------------------------------------------
const MIME_LABELS = {
  'image/png': 'PNG',
  'image/jpeg': 'JPEG',
  'image/jpg': 'JPG',
  'application/pdf': 'PDF'
};
const mimeToLabel = (mime) => MIME_LABELS[mime] || mime?.split('/')?.[1]?.toUpperCase() || mime;

const isImageMime = (mime) => !!mime && mime.startsWith('image/');
const isImageFile = (file) => !!file && file.type?.startsWith('image/');

// Normalizes one raw document coming from the API (requestedDocuments) into
// the shape this component works with internally.
const normalizeDocument = (doc, index) => ({
  id: doc.file_name ? `${doc.file_name}-${index}` : index,
  name: doc.file_name,
  subtitle: doc.remarks,
  category: doc.category,
  isMandatory: !!doc.is_mandatory,
  allowedTypes: doc.allowed_file_types || [],
  // Existing file already on record (from a previous upload), if any.
  existingUrl: doc.file_url || null,
  existingType: doc.file_type || null,
  // Locally selected replacement file (not yet submitted).
  file: null,
  previewUrl: null,
  status: doc.file_url ? 'UPLOADED' : 'PENDING' // PENDING -> READY (attached locally) -> UPLOADED
});

const DocumentVerificationComponent = ({
  requestedDocuments = [],
  onSubmit // (files: {id, name, file}[]) => Promise|void
}) => {
  const theme = useTheme();

  const [documents, setDocuments] = useState(() => requestedDocuments.map(normalizeDocument));
  const [expandedIds, setExpandedIds] = useState(() =>
    requestedDocuments.map((doc, index) => normalizeDocument(doc, index).id)
  );
  const [sectionOpen, setSectionOpen] = useState(true);
  const [submitting, setSubmitting] = useState(false);
console.log("requestedDocumentsNNNNNNNN", requestedDocuments)
  // Keep internal state in sync if the parent hands us a fresh document list.
  useEffect(() => {
    setDocuments(requestedDocuments.map(normalizeDocument));
    setExpandedIds(requestedDocuments.map((doc, index) => normalizeDocument(doc, index).id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestedDocuments]);

  // Revoke local object URLs on unmount to avoid memory leaks.
  useEffect(() => {
    return () => {
      documents.forEach((doc) => {
        if (doc.previewUrl) URL.revokeObjectURL(doc.previewUrl);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleCard = (id) => {
    setExpandedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleFileSelect = useCallback((id, event) => {
    const file = event.target.files?.[0];
    event.target.value = ''; // allow re-selecting the same file later
    if (!file) return;

    setDocuments((prev) =>
      prev.map((doc) => {
        if (doc.id !== id) return doc;
        if (doc.previewUrl) URL.revokeObjectURL(doc.previewUrl);
        return {
          ...doc,
          file,
          previewUrl: isImageFile(file) ? URL.createObjectURL(file) : null,
          status: 'READY'
        };
      })
    );
    setExpandedIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
  }, []);

  const handleClear = (id) => {
    setDocuments((prev) =>
      prev.map((doc) => {
        if (doc.id !== id) return doc;
        if (doc.previewUrl) URL.revokeObjectURL(doc.previewUrl);
        // Clearing a locally-picked replacement falls back to whatever was
        // already on record, not all the way to PENDING.
        return {
          ...doc,
          file: null,
          previewUrl: null,
          status: doc.existingUrl ? 'UPLOADED' : 'PENDING'
        };
      })
    );
  };

  // FIX: Count both UPLOADED and READY as "attached"
  const attachedCount = documents.filter((d) => d.status !== 'PENDING').length;
  const uploadedCount = documents.filter((d) => d.status === 'UPLOADED').length;
  const mandatoryDocs = documents.filter((d) => d.isMandatory);
  const mandatoryAttached = mandatoryDocs.filter((d) => d.status !== 'PENDING').length;
  const allMandatoryAttached = mandatoryDocs.length > 0 && mandatoryAttached === mandatoryDocs.length;
  const requestedDocumentsData = useSelector((state) => state.jobs?.documentsData);
  const AllDocsCheck = requestedDocumentsData?.uploaded_docs || [];

  const allHaveFileUrl = AllDocsCheck.every(item => 
  item?.file_url && item.file_url.trim() !== ''
);

console.log("All have file_url:", allHaveFileUrl);
  
  console.log("AllDocsCheckNNN", AllDocsCheck)
  
  // FIX: Check if all documents are either READY or UPLOADED (not just UPLOADED)
  const allDocumentsAttached = documents?.length > 0 && 
  documents.every((d) => d.status === 'PENDING' || d.status === 'UPLOADED');

//   const handleSubmit = async () => {
//     console.log("AMMMMAMAMAMAMAMA")
//   setSubmitting(true);
//   try {
//     // Create the payload with ALL document data
//     const payload = documents
//       .filter((d) => d.file) // only the newly-attached local files
//       .map((doc) => ({
//         id: doc.id,
//         name: doc.name,
//         file: doc.file,
//         subtitle: doc.subtitle || "",
//         category: doc.category || "Personal",
//         isMandatory: doc.isMandatory || false,
//         allowedTypes: doc.allowedTypes || [],
//         existingUrl: doc.existingUrl || null,
//         existingType: doc.existingType || null,
//         status: doc.status || "READY"
//       }));
    
//     // Log the payload to console
//     console.log("Document Upload Payload:", payload);
    
//     // Log each document's details for debugging
//     payload.forEach((doc, index) => {
//       console.log(`Document ${index + 1}:`, {
//         id: doc.id,
//         name: doc.name,
//         category: doc.category,
//         isMandatory: doc.isMandatory,
//         fileSize: doc.file.size,
//         fileType: doc.file.type,
//         fileName: doc.file.name
//       });
//     });
    
//     // Call the onSubmit prop with the payload
//     if (onSubmit) {
//       await onSubmit(payload);
//     } else {
//       // Fallback if no onSubmit provided
//       await new Promise((res) => setTimeout(res, 1200));
//     }
    
//     // After successful submission, mark all as UPLOADED
//     setDocuments((prev) => prev.map((doc) => ({ 
//       ...doc, 
//       status: 'UPLOADED',
//       // Clear the local file after successful upload
//       file: null,
//       previewUrl: null
//     })));
//   } catch (error) {
//     console.error('Submission error:', error);
//   } finally {
//     setSubmitting(false);
//   }
// };



const handleSubmit = async () => {
  console.log("Submitting documents...");
  setSubmitting(true);
  
  try {
    // Create the payload with ALL document data
    const payload = documents
      .filter((d) => d.file) // only the newly-attached local files
      .map((doc) => ({
        id: doc.id,
        name: doc.name,
        file: doc.file,
        subtitle: doc.subtitle || "",
        category: doc.category || "Personal",
        isMandatory: doc.isMandatory || false,
        fieldKey: doc.fieldKey || doc.name.toLowerCase().replace(/ /g, '_'),
        allowedTypes: doc.allowedTypes || [],
        existingUrl: doc.existingUrl || null,
        existingType: doc.existingType || null,
        status: doc.status || "READY"
      }));
    
    // Log the payload to console
    console.log("Document Upload Payload:", payload);
    
    // Log each document's details for debugging
    payload.forEach((doc, index) => {
      console.log(`Document ${index + 1}:`, {
        id: doc.id,
        name: doc.name,
        fieldKey: doc.fieldKey,
        category: doc.category,
        isMandatory: doc.isMandatory,
        fileSize: doc.file.size,
        fileType: doc.file.type,
        fileName: doc.file.name
      });
    });

    // Call the upload function
    await onSubmit(payload);
    
  } catch (error) {
    console.error("Error in handleSubmit:", error);
    // toast.error("Failed to submit documents");
  } finally {
    setSubmitting(false);
  }
};
  const getStatusChip = (status) => {
    const config = {
      PENDING: {
        label: 'PENDING',
        color: theme.palette.text.secondary,
        bgcolor: alpha(theme.palette.text.secondary, 0.08),
        icon: <ScheduleIcon sx={{ fontSize: 14 }} />
      },
      READY: {
        label: 'READY TO SUBMIT',
        color: theme.palette.info.main,
        bgcolor: alpha(theme.palette.info.main, 0.08),
        icon: <CheckCircleIcon sx={{ fontSize: 14 }} />
      },
      UPLOADED: {
        label: 'UPLOADED',
        color: theme.palette.success.main,
        bgcolor: alpha(theme.palette.success.main, 0.08),
        icon: <CheckCircleIcon sx={{ fontSize: 14 }} />
      }
    }[status];

    return (
      <Chip
        icon={config.icon}
        label={config.label}
        size="small"
        sx={{
          color: config.color,
          bgcolor: config.bgcolor,
          fontWeight: 600,
          fontSize: '10px',
          borderRadius: '6px',
          height: '24px',
          flexShrink: 0,
          '& .MuiChip-label': { px: 1, letterSpacing: '0.3px' }
        }}
      />
    );
  };

  return (
    <Box sx={{ bgcolor: '#f8fafc', borderRadius: '14px', overflow: 'hidden', border: `1px solid ${theme.palette.divider}` }}>
      {/* White header */}
      <Box
        sx={{
          bgcolor: '#ffffff',
          px: 2.5,
          py: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: sectionOpen ? `1px solid ${theme.palette.divider}` : 'none'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DescriptionIcon sx={{ fontSize: 20, color: theme.palette.text.primary }} />
          <Typography sx={{ fontWeight: 700, fontSize: '16px', color: theme.palette.text.primary }}>
            Document Verification
          </Typography>
          <IconButton size="small" onClick={() => setSectionOpen((p) => !p)} sx={{ ml: 0.5 }}>
            <ExpandMoreIcon
              sx={{
                fontSize: 20,
                transform: sectionOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease'
              }}
            />
          </IconButton>
        </Box>

        {/* FIX: Show "Attached" instead of "Uploaded" */}
        <Chip
          label={`${attachedCount} / ${documents.length} Attached`}
          size="small"
          sx={{
            fontWeight: 600,
            fontSize: '11px',
            bgcolor: alpha(theme.palette.text.primary, 0.06),
            color: theme.palette.text.secondary,
            borderRadius: '8px'
          }}
        />
      </Box>

      {sectionOpen && (
        <Box sx={{ p: 2.5 }}>
          {documents.length === 0 && (
            <Typography sx={{ fontSize: '13px', color: theme.palette.text.secondary, textAlign: 'center', py: 4 }}>
              No documents have been requested yet.
            </Typography>
          )}

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: 2
            }}
          >
            {documents.map((doc) => {
              const isOpen = expandedIds.includes(doc.id);
              const hasNewFile = !!doc.file;
              const hasExisting = !hasNewFile && !!doc.existingUrl;
              const hasFile = hasNewFile || hasExisting;

              const previewUrl = hasNewFile ? doc.previewUrl : doc.existingUrl;
              const previewIsImage = hasNewFile ? isImageFile(doc.file) : isImageMime(doc.existingType);
              const fileLabel = hasNewFile
                ? doc.file.name
                : doc.existingUrl?.split('/').pop()?.split('?')[0];

              return (
                <Accordion
                  key={doc.id}
                  expanded={isOpen}
                  onChange={() => toggleCard(doc.id)}
                  disableGutters
                  elevation={0}
                  sx={{
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: '12px !important',
                    bgcolor: '#ffffff',
                    '&:before': { display: 'none' },
                    overflow: 'hidden'
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fontSize: 20 }} />}
                    sx={{
                      px: 2,
                      py: 1,
                      '& .MuiAccordionSummary-content': {
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                        my: 1
                      }
                    }}
                  >
                    <Box sx={{ minWidth: 0 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: '14px',
                            color: theme.palette.text.primary,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                        >
                          {doc.name}
                        </Typography>
                        {doc.isMandatory && (
                          <Typography sx={{ fontSize: '11px', fontWeight: 700, color: theme.palette.error.main }}>
                            *
                          </Typography>
                        )}
                      </Box>
                      <Typography
                        variant="caption"
                        sx={{ color: theme.palette.text.secondary, fontSize: '12px', display: 'block' }}
                      >
                        {doc.subtitle}
                      </Typography>
                    </Box>
                    {getStatusChip(doc.status)}
                  </AccordionSummary>

                  <AccordionDetails sx={{ px: 2, pt: 0, pb: 2 }}>
                    {/* Preview area */}
                    <Box
                      sx={{
                        height: 150,
                        borderRadius: '10px',
                        bgcolor: alpha(theme.palette.text.primary, 0.03),
                        border: `1px dashed ${theme.palette.divider}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 1.5,
                        overflow: 'hidden'
                      }}
                    >
                      {!hasFile && (
                        <Box sx={{ textAlign: 'center', color: theme.palette.text.disabled }}>
                          <CloudUploadIcon sx={{ fontSize: 28, mb: 0.5 }} />
                          <Typography sx={{ fontSize: '12px' }}>No file attached yet</Typography>
                        </Box>
                      )}

                      {hasFile && previewIsImage && (
                        <Box
                          component="img"
                          src={previewUrl}
                          alt={doc.name}
                          sx={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                        />
                      )}

                      {hasFile && !previewIsImage && (
                        <Box sx={{ textAlign: 'center', px: 2 }}>
                          <FileIcon sx={{ fontSize: 32, color: theme.palette.primary.main, mb: 0.5 }} />
                          <Typography
                            sx={{
                              fontSize: '12px',
                              fontWeight: 600,
                              color: theme.palette.primary.main,
                              wordBreak: 'break-all'
                            }}
                          >
                            {fileLabel}
                          </Typography>
                          {hasNewFile && (
                            <Button
                              size="small"
                              onClick={() => handleClear(doc.id)}
                              startIcon={<CloseIcon sx={{ fontSize: 14 }} />}
                              sx={{ fontSize: '10px', color: theme.palette.error.main, mt: 0.5 }}
                            >
                              Clear
                            </Button>
                          )}
                        </Box>
                      )}
                    </Box>

                    {hasNewFile && previewIsImage && (
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                        <Button
                          size="small"
                          onClick={() => handleClear(doc.id)}
                          startIcon={<CloseIcon sx={{ fontSize: 14 }} />}
                          sx={{ fontSize: '10px', color: theme.palette.error.main }}
                        >
                          Clear
                        </Button>
                      </Box>
                    )}

                    <Divider sx={{ mb: 1.5 }} />

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 1
                      }}
                    >
                      <Typography sx={{ fontSize: '10px', fontWeight: 600, color: theme.palette.text.secondary }}>
                        FORMATS: {doc.allowedTypes.map(mimeToLabel).join(', ')}
                      </Typography>

                      <Box sx={{ display: 'flex', gap: 1 }}>
                        {hasFile && (
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<VisibilityIcon sx={{ fontSize: 15 }} />}
                            onClick={() => window.open(previewUrl, '_blank')}
                            sx={{
                              fontSize: '11px',
                              fontWeight: 600,
                              textTransform: 'none',
                              borderRadius: '8px'
                            }}
                          >
                            View
                          </Button>
                        )}
                        <Button
                          component="label"
                          variant="outlined"
                          size="small"
                          startIcon={<CloudUploadIcon sx={{ fontSize: 15 }} />}
                          sx={{ fontSize: '11px', fontWeight: 600, textTransform: 'none', borderRadius: '8px' }}
                        >
                          {hasFile ? 'Change' : 'Click to upload file'}
                          <input
                            type="file"
                            hidden
                            accept={doc.allowedTypes.join(',')}
                            onChange={(e) => handleFileSelect(doc.id, e)}
                          />
                        </Button>
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>

          {/* Submit bar - FIX: Use allDocumentsAttached instead of allSubmitted */}
          {documents.length > 0 && (
            <Box
              sx={{
                mt: 3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 1.5
              }}
            >
              {allHaveFileUrl ?  "" : <Typography sx={{ fontSize: '12px', color: theme.palette.text.secondary }}>
                {allDocumentsAttached 
                  ? 'All documents attached and ready for submission.'
                  : `${mandatoryAttached} / ${mandatoryDocs.length} required document(s) attached`}
              </Typography>}

              {allHaveFileUrl ? "" : <Button
                variant="contained"
                // disabled={ submitting || allDocumentsAttached}
                onClick={handleSubmit}
                startIcon={submitting ? <CircularProgress size={16} sx={{ color: '#fff' }} /> : null}
                sx={{
                  fontSize: '12px',
                  fontWeight: 600,
                  textTransform: 'none',
                  px: 4,
                  py: 0.9,
                  borderRadius: '8px',
                  boxShadow: 'none'
                }}
              >
                {allDocumentsAttached ? 'Submit' : submitting ? 'Submitting...' : 'Submit'}
              </Button>}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default DocumentVerificationComponent;